import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, } from '@angular/core';
import { SharedService, SharedUserDataService } from '@core/services/shared';
import { UtilsService } from '@core/services/utils';
import { filter, Subject, takeUntil } from 'rxjs';

@Component({
  selector: "executive",
  templateUrl: "./executive.component.html",
  styleUrls: ["./executive.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExecutiveComponent implements OnInit, OnDestroy, AfterViewInit {
  /**
   * Constructor
   */
  constructor(
    private _shrdUsrInfo: SharedUserDataService,
    private _cRef: ChangeDetectorRef,
    private _utilS: UtilsService) { }
  dExecutive: any = {};

  private _unsubscribeExectiv: Subject<void> = new Subject();

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------
  /**
   * On init
   */
  ngOnInit(): void {

    this._shrdUsrInfo.getDataUserSession$
      .pipe(
        filter((value) => value !== null),
        takeUntil(this._unsubscribeExectiv)
      )
      .subscribe((dataRecieve) => {

        switch (dataRecieve.origin) {

          case 'infoSessionClient':
            if (!this._utilS.isEmpty(dataRecieve.data)) {
              this.dExecutive = dataRecieve.data;
              this._cRef.markForCheck();
            }
            break;
        }
      })

  }

  ngOnDestroy(): void {
    this._unsubscribeExectiv.next();
    this._unsubscribeExectiv.complete();

  }

  ngAfterViewInit(): void {
    this._cRef.detectChanges();
  }


  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------
  loadDataExecutive() {

  }
  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------
}
